import homeAboutImg from "../../../assets/img/HomePage/Desktop/home_about_img.png";
import { homeAboutContent } from "../../HomePage/content";
import HomeAboutStoryBody from "../../HomePage/HomeAboutStoryBody";

const HomeAbout = () => {
  return (
    <section className="pl-0 pr-4 sm:pr-8 lg:pr-12 xl:pr-16 2xl:pr-[100px]">
      <div className="relative w-full max-w-[1720px] ml-0 mr-auto">
        <div className="flex flex-col xl:flex-row xl:items-center gap-6 xl:gap-0">
          {/* Image Box */}
          <img
            src={homeAboutImg}
            alt={homeAboutContent.imageAlt}
            className="w-full max-w-[1020px] shrink-0 object-cover xl:w-[min(1020px,62%)] xl:min-w-0 xl:shrink"
          />

          {/* Text Box - below xl: max-w-xl; xl+: flex-1 fills row to match section pr-* (no fixed max width) */}
          <div className="relative z-10 mx-auto w-full min-w-0 max-w-xl xl:mx-0 xl:-ml-24 xl:flex-1 xl:max-w-none 2xl:-ml-32">
            <div className="bg-text-1000/20 rounded-[8px] p-2 sm:p-[10px]">
              <div className="bg-text-1000 shadow-xl shadow-text-0/24 rounded-[8px] px-6 py-8 sm:px-10 sm:py-8 xl:px-[56px] xl:py-[40px]">
                <p className="text-[16px] font-open-sans font-bold text-primaryDark-0 mb-[8px]">
                  {homeAboutContent.eyebrow}
                </p>

                <h3 className="text-[28px] xl:text-[36px] font-raleway font-semibold leading-tight text-primaryDark-0 mb-4 xl:mb-5">
                  <span className="text-primaryDark-400">
                    {" "}
                    {homeAboutContent.titleHighlight}{" "}
                  </span>
                  {homeAboutContent.titleRest}
                </h3>

                <HomeAboutStoryBody bodyClassName="text-[16px] xl:text-[17px] font-open-sans text-text-0 leading-[1.65]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;
